import { IConfig } from './IConfig';

const config: IConfig = process.env.NODE_ENV === 'development'
    ? require('./development').default
    : require('./production').default;

export default config;
